import Polymorph from './Polymorph';

export default Polymorph;
